import * as React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { compose, withHandlers, withProps } from 'recompose';
import { reduxForm, formValueSelector } from 'redux-form';
import { Row, Col, Grid } from 'react-flexbox-grid';
import {
  RemoteAutoCompleteField,
  RemoteAutoComplete,
  InputField,
  Input,
  AutoCompleteField,
  AutoComplete,
  DateField,
  Date
} from '@components/form';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { paymentMethodEnum } from '@modules/delicts/_delictsEnums';
import { payDelict } from '@modules/delicts/_delictsActions';
import { withNotifications } from '@components/hoc/withNotifications';
import { required } from '@utils/validators';
import { getActualDate } from '@utils/utils';

const enhance = compose<any, any>(
  withNotifications({ payDelict }),
  withHandlers({
    onSubmit: ({ isBNP, reloadDelict, delictId, closeItem, payDelictNotify }) => async ({
      employeeId,
      ...formData
    }) => {
      const result = await payDelictNotify({ isBNP, id: delictId, ...formData });
      if (result) {
        await reloadDelict();
        closeItem();
      }
    }
  }),
  withProps({
    initialValues: {
      useDate: getActualDate()
    }
  }),
  reduxForm({ form: 'module-events-delicts-payment' }),
  connect(state => ({
    employeeId: formValueSelector('module-events-delicts-payment')(state, 'employeeId')
  }))
);

const View: React.SFC<any> = ({ handleSubmit, closeItem, isBNP, employeeId }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <h4>{isBNP ? 'Vydat BNP' : 'Pokuta zaplacena na místě'}</h4>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  name={'employeeId'}
                  label="Zaměstnanec *"
                  url={`/metropolis/api/hr/employees`}
                  fullWidth={true}
                  labelFunction={o => get(o, 'fullName')}
                  valueFunction={o => get(o, 'id')}
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  name={`${isBNP ? 'bnp' : 'bnz'}Id`}
                  label="Doklad *"
                  url={'/metropolis/api/ed/tickets'}
                  params={{
                    sort: 'intNumber',
                    order: 'ASC',
                    filter: [
                      {
                        field: 'employee.id',
                        operation: 'EQ',
                        value: employeeId
                      },
                      {
                        field: 'type.id',
                        operation: 'EQ',
                        value: isBNP ? 'BNP' : 'BNZ'
                      },
                      {
                        field: 'state.id',
                        operation: 'EQ',
                        value: 'ISSUED'
                      }
                    ]
                  }}
                  fullWidth={true}
                  labelFunction={o => get(o, 'fullNumber')}
                  valueFunction={o => get(o, 'id')}
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <InputField component={Input} name={'value'} label={'Suma *'} type={'number'} validate={[required]} />
              </Col>
            </Row>
            {!isBNP && (
              <Row>
                <Col md={12}>
                  <AutoCompleteField
                    component={AutoComplete}
                    name={'paymentMethod'}
                    label={'Způsob platby *'}
                    items={paymentMethodEnum}
                    labelFunction={o => get(o, 'label')}
                    valueFunction={o => get(o, 'id')}
                    validate={[required]}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col md={12}>
                <DateField
                  component={Date}
                  label="Datum a čas užití bloku *"
                  name="useDate"
                  validate={[required]}
                  dateOnly={false}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Button label="Uložit a zavřít" primary={true} type={'submit'} style={{ margin: '8px' }} />
        <Button label="Zrušit" style={{ margin: '8px' }} onClick={closeItem} />
      </Grid>
    </form>
  </div>
);

export const EventsFormDelictsPaymentForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormDelictsPaymentForm.tsx